import { render, staticRenderFns } from "./washingLabelRequire.vue?vue&type=template&id=d15058f2&scoped=true&"
import script from "./washingLabelRequire.vue?vue&type=script&lang=js&"
export * from "./washingLabelRequire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15058f2",
  null
  
)

export default component.exports